/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from '../../../../../../../../generated/graphql/types';

export type BannerCampaignFieldsFragment = {
  __typename?: 'BannerCampaign';
} & Pick<
  Types.BannerCampaign,
  | 'name'
  | 'id'
  | 'attributes'
  | 'userSegments'
  | 'title'
  | 'sponsor'
  | 'advertiser'
  | 'pageType'
  | 'trackingId'
> & {
    image: Types.Maybe<
      { __typename?: 'BannerCampaignImage' } & Pick<
        Types.BannerCampaignImage,
        'desktopUrl' | 'mobileUrl' | 'altText'
      >
    >;
    link: Types.Maybe<
      { __typename?: 'BannerCampaignLink' } & Pick<
        Types.BannerCampaignLink,
        'url' | 'target'
      >
    >;
    abTest: Types.Maybe<
      { __typename?: 'ABTest' } & Pick<Types.AbTest, 'id' | 'feature'>
    >;
    featureFlag: Types.Maybe<
      { __typename?: 'FeatureFlag' } & Pick<Types.FeatureFlag, 'id' | 'active'>
    >;
  };

export const BannerCampaignFieldsFragmentDoc = /*#__PURE__*/ `
    fragment BannerCampaignFields on BannerCampaign {
  name
  id
  attributes
  userSegments
  title
  sponsor
  advertiser
  pageType
  trackingId
  image {
    desktopUrl
    mobileUrl
    altText
  }
  link {
    url
    target
  }
  abTest {
    id
    feature
  }
  featureFlag {
    id
    active
  }
}
    `;
